export const HomeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22 7 12 1 2 7v16h20zM12 2.458l8.75 5.25V21.75h-8.125V15h-1.25v6.75H3.25V7.708z"
        clipRule="evenodd"
      ></path>
    </g>
  </svg>
);
